import {
  GOLOS_NARODA_WIDGET_SLIDE_COUNT
} from './constants';

const isMobile = () => window.matchMedia('(max-width: 755px)').matches;
const isDesktop = () => window.matchMedia('(min-width: 1152px)').matches;

const getRuUrl = window.location.origin.replace('kaz', 'www');

const getSlidesCount = () => {
  if (isMobile() || isDesktop()) {
    return GOLOS_NARODA_WIDGET_SLIDE_COUNT.SMALL;
  }

  return GOLOS_NARODA_WIDGET_SLIDE_COUNT.BIG;
};

const getPrevious = (index, lastIndex) => {
  if (index !== 0) {
    return index - 1;
  }
  return lastIndex;
};

const getIsRightDirection = (current, next) => {
  if (Math.abs(next - current) === 1) {
    return next - current > 0;
  }
  return next - current <= 0;
};

const getImageSrc = photo => photo?.formats?.thumbnail?.url || photo?.url;

export {getSlidesCount, isMobile, isDesktop, getImageSrc, getRuUrl, getIsRightDirection, getPrevious};
